import {useIntl} from 'react-intl';
import {FlexProps, Flex, Text} from '@chakra-ui/react';

import {useTranslate} from '@eksab/i18n';

import {StarHalfIcon} from '@eksab/features/profile/icons';

import {useTriviaStore} from '../state';

export const QuestionPoints = (props: FlexProps) => {
  const format = useIntl().formatNumber;

  const t = useTranslate();
  const points = useTriviaStore((state) => state.points);

  return (
    <Flex align="center" gap="0.5" ps={[3, 4]} pe={[4, 6]} py="2" rounded="full" bg="#e6f6eb" {...props}>
      <StarHalfIcon />

      <Text fontSize={{base: 'xs', lg: 'md'}} fontWeight="500">
        {t('trivia.score.points', {
          points: (
            <Text as="b" fontSize={{base: 'md', lg: '2xl'}} fontWeight="800" color="#408c57">
              {format(points)}
            </Text>
          ),
        })}
      </Text>
    </Flex>
  );
};
